import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
export const getPriorityStatusDot = value => {
  // Property options: https://tools.hubteam.com/puma/objects/TASK/properties/hs_task_priority/details/
  switch (value) {
    case 'LOW':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        "data-test-id": "priority-status-dot-low",
        use: "success"
      });

    case 'MEDIUM':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        "data-test-id": "priority-status-dot-medium",
        use: "warning"
      });

    case 'HIGH':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        "data-test-id": "priority-status-dot-high",
        use: "danger"
      });

    case 'NONE':
    default:
      return undefined;
  }
};

const FormattedPriorityStatus = ({
  property,
  value
}) => {
  if (value === null || value === undefined || value === '') {
    return /*#__PURE__*/_jsx("span", {
      children: EMPTY_PROPERTY_VALUE
    });
  }

  return /*#__PURE__*/_jsxs("span", {
    children: [getPriorityStatusDot(value), getDisplayedValue(property, value)]
  });
};

export default FormattedPriorityStatus;